import path from 'node:path'

/**
 * Returns the name and extension of a file
 */
export function getFileInfo(file: string) {
  const extension = path.extname(file)
  const name = path.basename(file, extension)

  return {
    name,
    extension,
  }
}
